import React from "react";
import { Link } from "react-router-dom";


import "../Pages/Projects.css";

const Projects = () => {
  return (
    <section className="Container">

<div className="Card">
            <div className="Card-image card-17"></div>
            <h2 className="Title">Covid19-Screening Application</h2>
            <p className="Text">Created responsive application which allows company to keep health check of employee's.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, Node Js, MongoDB</p>
            <button className="Btn" type="button"    onClick={(e) => {  e.preventDefault();  window.location.href='https://covid19-screening-app23.herokuapp.com/';  }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/covid19-registration';  }}>Code</button>
            </div>

            <div className="Card">
            <div className="Card-image card-13"></div>
            <h2 className="Title">Weather Application</h2>
            <p className="Text">Created application which shows user accurate Weather information and for different location.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, API, VScode</p>
            <button className="Btn" type="button"    onClick={(e) => {  e.preventDefault();  window.location.href='https://silly-snyder-9630cd.netlify.app/';  }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/Weather-app.git';  }}>Code</button>
            </div>



      <div className="Card">
        <div className="Card-image card-15"></div>
        <h2 className="Title">To Do Application</h2>
            <p className="Text">Designed and created this application to help manage tasks and remove them when done.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript</p>
            <button className="Btn" type="button" onClick={(e) => {e.preventDefault();window.location.href='https://pensive-banach-4f6faa.netlify.app/';}}>Project</button>
             <button className="Btn" type="button" onClick={(e) => { e.preventDefault(); window.location.href='https://github.com/pate0845/To-Do/tree/master';}}>Code</button>
      </div>


      <div className="Card">
        <div className="Card-image card-16"></div>
        <h2 className="Title">BattleShip Game</h2>
            <p className="Text">Using JavaScript created this Sing Page Application.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, Firebase</p>
            <button className="Btn" type="button" onClick={(e) => {e.preventDefault();window.location.href='https://festive-morse-def2de.netlify.app/';}}>Project</button>
             <button className="Btn" type="button" onClick={(e) => { e.preventDefault(); window.location.href='https://github.com/pate0845/Battle-Ship';}}>Code</button>
      </div>

      <div className="Card">
            <div className="Card-image card-12"></div>
            <h2 className="Title">Music Application</h2>
            <p className="Text">Created mobile application which allows user to search for albums.</p>
            <p className="tech"><b>Technologies: </b>XML, Java, JSON, AndroidStudio</p>
            <button className="Btn" type="button"    onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/Android_Application/tree/Songster-API';  }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/Android_Application/tree/Songster-API';  }}>Code</button>
            </div>

      <div className="Card">
        <div className="Card-image card-1"></div>
        <h2 className="Title">Game Database</h2>
            <p className="Text">Using Angular CLI and public API  generate a game database website.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, API, Angular, Firebase</p>
            <button className="Btn" type="button" onClick={(e) => {e.preventDefault();window.location.href='https://game-database-306.web.app/';}}>Project</button>
             <button className="Btn" type="button" onClick={(e) => { e.preventDefault(); window.location.href='https://github.com/pate0845/Game_DataBase.git';}}>Code</button>
      </div>

      <div className="Card">
          <div className="Card-image card-10"></div>
            <h2 className="Title">Tesla Clone</h2>
            <p className="Text">An application built using React Js implementing usage of Props, Components and Icons </p>
            <p className="tech"><b>Technologies: </b>React Js, JavaScript, Firebase</p>
            <button className="Btn" type="button"    onClick={(e) => {  e.preventDefault();  window.location.href='https://tesla-clone-333.web.app/';  }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/Tesla-Clone.git';  }}>Code</button>
          </div>

          <div className="Card">
            <div className="Card-image card-14"></div>
            <h2 className="Title">Chat Application</h2>
            <p className="Text">Created chat application which saves message to database and implement CRUD.</p>
            <p className="tech"><b>Technologies: </b>XML, Java, SQlite, AndroidStudio</p>
            <button className="Btn" type="button"    onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/AndroidApplications/tree/Lab8/';  }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/AndroidApplications/tree/Lab8/';  }}>Code</button>
            </div>

      <div className="Card">
          <div className="Card-image card-5"></div>
            <h2 className="Title">Budget Calculator</h2>
            <p className="Text"> Created this budget calculating app to keep track of expenses. </p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, Angular </p>
            <button className="Btn" type="button"   onClick={(e) => {   e.preventDefault();  window.location.href='https://budget-calculator-306.web.app/';}}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {e.preventDefault();window.location.href='https://github.com/pate0845/budget-app.git';}}>Code</button>
          </div>

          <div className="Card">
          <div className="Card-image card-6"></div>
            <h2 className="Title">Rock Paper Scissor</h2>
            <p className="Text"> Created this amazing Stone Paper Scissor web application. </p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, Netlify</p>
            <button className="Btn" type="button" onClick={(e) => { e.preventDefault(); window.location.href='https://frosty-wescoff-c4931d.netlify.app/'; }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => { e.preventDefault(); window.location.href='https://github.com/pate0845/RockPaperScissor.git'; }}>Code</button>
            </div>


            <div className="Card">
          <div className="Card-image card-11"></div>
            <h2 className="Title">Tic Tac Toe</h2>
            <p className="Text">An application built using React Js Documentation to gain in depth knowledge about React Js.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, React Js</p>
            <button className="Btn" type="button"    onClick={(e) => {  e.preventDefault();  window.location.href='https://tic-tac-toe-f12f5.web.app/';  }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/tic-tac-toe';  }}>Code</button>
          </div>


          <div className="Card">
          <div className="Card-image card-4"></div>
            <h2 className="Title">Minion Translator</h2>
            <p className="Text">  A translation application build using Translation API and JavaScript.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, API, NodeJs, AJAX</p>
            <button className="Btn" type="button"   onClick={(e) => {   e.preventDefault();   window.location.href='https://unruffled-pare-cb1dda.netlify.app/';   }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/Translator.git';  }}>Code</button>
            </div>
  

            <div className="Card">
          <div className="Card-image card-2"></div>
            <h2 className="Title">Watch Store</h2>
            <p className="Text">Responsive website to load data dynamically and working search bar.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, PHP, SQL, Heroku</p>
            <button className="Btn" type="button" onClick={(e) => { e.preventDefault(); window.location.href='https://website-e.herokuapp.com/project.php'; }}>Project</button>
            <button className="Btn" type="button"  onClick={(e) => { e.preventDefault();window.location.href='https://github.com/pate0845/e-comweb.git';   }}>Code</button>
     </div>

          <div className="Card">
          <div className="Card-image card-3"></div>
            <h2 className="Title">E-com Website</h2>
            <p className="Text">Created UI for e-com website with code maintainability and detail-oriented products display.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, Bootstrap</p>
            <button className="Btn" type="button"  onClick={(e) => {  e.preventDefault();  window.location.href='https://ui-websites.herokuapp.com/index.php';  }}>Project</button>
            <button className="Btn" type="button"  onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/ui-websites.git';  }}>Code</button>
            </div>


          <div className="Card">
          <div className="Card-image card-7"></div>
            <h2 className="Title">ToDo Application</h2>
            <p className="Text">Created ToDo application with Angular.</p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, Angular</p>
            <button className="Btn" type="button"  onClick={(e) => { e.preventDefault(); window.location.href='https://todo-list-306.firebaseapp.com/'; }}>Project</button>
            <button className="Btn" type="button" onClick={(e) => { e.preventDefault(); window.location.href='https://github.com/pate0845/TODO-List.git'; }}>Code</button>
            </div>

          <div className="Card">
          <div className="Card-image card-8"></div>
            <h2 className="Title">Quiz App</h2>
            <p className="Text"> A CLI quiz application to check your knowledge about Computers.          </p>
            <p className="tech"><b>Technologies: </b>NodeJs, repl</p>
            <button className="Btn" type="button"  onClick={(e) => { e.preventDefault(); window.location.href='https://replit.com/@Rutvik306/JealousForestgreenDisassembler?v=1'; }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://replit.com/@Rutvik306/JealousForestgreenDisassembler?v=1';  }}>Code</button>
            </div>
    
          <div className="Card">
          <div className="Card-image card-9"></div>
            <h2 className="Title">Bank Application</h2>
            <p className="Text">An application built using JavaScript on Higher order array methods. </p>
            <p className="tech"><b>Technologies: </b>HTML, CSS, JavaScript, API</p>
            <button className="Btn" type="button"    onClick={(e) => {  e.preventDefault();  window.location.href='https://keen-panini-825441.netlify.app/';  }}>Project</button>
            <button className="Btn" type="button"onClick={(e) => {  e.preventDefault();  window.location.href='https://github.com/pate0845/Bank-Application.git';  }}>Code</button>
          </div>

    </section>
  );
};

export default Projects; 
